import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
    fetchStats, 
    fetchYearlySales, 
    fetchSalesByLocation,
    changeYear 
} from '../../store/modules/dashboard/dashboardActions';

// Chart.js imports - Register once
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Import dashboard components
import StatsCards from './components/StatsCards';
import YearlySalesChart from './components/YearlySalesChart';
import SalesByLocationChart from './components/SalesByLocationChart';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels, CategoryScale, LinearScale, BarElement);

const Dashboard = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { 
        stats, 
        yearlySales, 
        salesByLocation, 
        loading, 
        error, 
        selectedYear 
    } = useSelector((state) => state.dashboard);

    const hasInitialized = useRef(false);

    useEffect(() => {
        // Prevent duplicate API calls in React StrictMode
        if (!hasInitialized.current) {
            hasInitialized.current = true;
            // Fetch all dashboard data separately when component mounts
            dispatch(fetchStats());
            dispatch(fetchYearlySales());
            dispatch(fetchSalesByLocation());
        }
    }, [dispatch]);

    const handleYearChange = (year) => {
        dispatch(changeYear(year));
        dispatch(fetchYearlySales(year));
    };

    return (
        <div className="container-fluid pb-4">
            <StatsCards 
                stats={stats} 
                loading={loading.stats} 
                error={error}
            />

            <div className="row g-4">
                <div className="col-12 col-xl-8">
                    <YearlySalesChart 
                        yearlySales={yearlySales}
                        loading={loading.yearlySales}
                        selectedYear={selectedYear}
                        onYearChange={handleYearChange}
                    />
                </div>

                <div className="col-12 col-xl-4">
                    <SalesByLocationChart 
                        salesByLocation={salesByLocation}
                        loading={loading.salesByLocation}
                    />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;